import React from 'react';

export default () => {
  return (
    <div className="container py-5 container-line">
      <div className="row ">
        <div className="col flex-column">
          <h2 className="subtitle bigger without">
            JavaScript development services will support your business in
            different fields
          </h2>
        </div>
      </div>
      <div className="row justify-content-between">
        <div className="col-12 col-lg-4 text-format">
          <ul className="px-4">
            <li className="fixed-height">
              Create a
              <span className="font-weight-bold"> lightweight app </span> that
              loads at the speed of light and is always there when a user needs
              it.
            </li>
            <li>
              Offer
              <span className="font-weight-bold"> intuitive interface </span>
              design to ease everyday use.
            </li>
          </ul>
        </div>
        <div className="col-12 col-lg-4 text-format">
          <ul className="px-4">
            <li className="fixed-height">
              Provide a
              <span className="font-weight-bold"> responsive app </span> that
              works flawlessly on desktop and mobile.
            </li>
            <li>
              Build trust with
              <span className="font-weight-bold">
                {' '}
                secure frontend solutions
              </span>
              .
            </li>
          </ul>
        </div>
        <div className="col-12 col-lg-4 text-format">
          <ul className="px-4">
            <li className="fixed-height">
              Provide <span className="font-weight-bold"> scalable </span> and
              high-performing frontend solutions for exceptional user
              experience.
            </li>
            <li>
              <span className="font-weight-bold">
                Improve end-user engagement{' '}
              </span>
              through incorporating cutting-edge techniques.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
